const STORAGE_KEY = 'defera_reserve_act_as_user_id';

let missingAnonKeyWarned = false;

/** Supabase Auth user id to impersonate on Reserve APIs (admin support). Persists for the tab session. */
export function getReserveActAsUserId() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function setReserveActAsUserId(userId) {
  try {
    if (userId && String(userId).trim()) {
      sessionStorage.setItem(STORAGE_KEY, String(userId).trim());
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore */
  }
}

/**
 * Headers for same-origin `/api/*` Reserve routes (Vercel + Express). Only adds act-as when set.
 * Do not add `apikey` here: same-origin requests already send a normal header budget; duplicating the
 * Supabase anon JWT via `apikey` on top of `Authorization` can exceed proxy limits (431) in production.
 */
export function mergeReserveActAsHeaders(headers = {}) {
  const id = getReserveActAsUserId();
  if (!id) return { ...headers };
  return { ...headers, 'X-Defera-Act-As-User': id };
}

/**
 * Headers for raw `fetch` to Supabase Edge (`*.supabase.co/functions/v1/*`). Gateway expects
 * `apikey` (anon) with `Authorization: Bearer <user_jwt>`; the JS client's `functions.invoke` adds
 * `apikey` automatically.
 */
export function mergeSupabaseEdgeHeaders(headers = {}) {
  const anon = typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_ANON_KEY;
  if (!anon && typeof window !== 'undefined' && !missingAnonKeyWarned) {
    missingAnonKeyWarned = true;
    console.warn(
      '[Defera] VITE_SUPABASE_ANON_KEY missing from the built bundle. Supabase Edge calls need it. In Vercel, add it for Production and redeploy so Vite can embed it.',
    );
  }
  const withGateway = anon ? { ...headers, apikey: anon } : { ...headers };
  const id = getReserveActAsUserId();
  if (!id) return withGateway;
  return { ...withGateway, 'X-Defera-Act-As-User': id };
}
